module.exports = __webpack_public_path__ + "static/media/logo_horizontal2.9b29d41b.png";